import styled from 'styled-components'

export const GuidanceWrapper = styled.div`
  width: 100%;
  margin-top: 75px;

  iframe {
    border: none;
    display: block;
    width: 100%;
  }
`
